import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const Domain = GlassFrogModel.extend({
}, {
  resourceName: 'domains',
})

export default Domain
